/** Shown when an author supplies a link URL but no wording for it. */
export const defaultCtaLabel = "Learn more";

/** Shown when an author supplies a video URL but no wording for it. */
export const defaultVideoLabel = "Watch video";

/** Client mirror of the server's http/https check. Lenient on purpose: the server decides. */
export function isAbsoluteHttpUrl(value: string): boolean {
    // The URL parser fills in missing slashes (`http:foo.com`), so check the prefix first.
    if (!/^https?:\/\/[^/]/i.test(value)) {
        return false;
    }

    try {
        const url = new URL(value);
        // .NET rejects an empty label (`foo..com`) but accepts a trailing dot.
        const hasEmptyLabel = url.hostname.replace(/\.$/, "").split(".").includes("");
        return (url.protocol === "http:" || url.protocol === "https:") && !hasEmptyLabel;
    } catch {
        return false;
    }
}

const appHost = "buildertrend.net";

/** True only for the app itself. Subdomains (help centre, learn, other environments) are separate sites. */
export function isInternalUrl(url: string): boolean {
    try {
        return new URL(url).hostname.toLowerCase() === appHost;
    } catch {
        return false;
    }
}
